import { Component, Input, OnInit } from '@angular/core';
import { FileService } from 'app/services/file.service';

@Component({
  selector: 'attachment-preview',
  templateUrl: './attachment-preview.component.html',
})
export class AttachmentPreviewComponent implements OnInit {
  @Input() uuid?: string;
  @Input() file: string;
  @Input() size: number;
  @Input() date: string;
  @Input() showDownloadButton: boolean = true;
  @Input() iconWidth: string = 'w-10';
  @Input() hideInfo: boolean = false;
  @Input() rawFile?: File = null;

  fileName: string;
  extension: string;
  fileSize: string;
  icon: string;
  isExternal = false;

  constructor(private fileService: FileService) {}

  ngOnInit(): void {
    this.fileName = this.getFileName();
    this.extension = this.getFileExtension();
    this.fileSize = this.formatFileSize();

    if (this.extension === 'pdf') {
      this.isExternal = false;
      this.icon = 'assets/images/extensions/pdf-icon.svg';
    } else if (['doc', 'docx'].includes(this.extension)) {
      this.isExternal = false;
      this.icon = 'assets/images/extensions/doc-icon.svg';
    } else if (['xls', 'xlsx'].includes(this.extension)) {
      this.isExternal = false;
      this.icon = 'assets/images/extensions/xls-icon.svg';
    } else if (this.rawFile && this.rawFile.type.startsWith('image/')) {
      this.isExternal = false;

      const reader = new FileReader();

      reader.onload = (event: ProgressEvent<FileReader>) => {
        this.icon = event.target?.result as string;
      };

      reader.readAsDataURL(this.rawFile);
    } else if (['png', 'jpg', 'jpeg', 'gif'].includes(this.extension)) {
      this.isExternal = true;

      this.loadFilePreview();
    } else {
      this.isExternal = false;
      this.icon = 'assets/images/extensions/undefined-icon.svg';
    }
  }
  private async loadFilePreview(): Promise<void> {
    if (this.uuid) {
      this.icon = await this.fileService.fetchFileOrFallback(this.uuid);
    } else if (this.file) {
      this.icon = this.file;
    }
  }
  getFileExtension() {
    const extension = this.file.split('.').pop();

    return extension;
  }

  getFileName() {
    const filename = this.file.split('/').pop();

    return filename;
  }
  onViewFile(): void {
    this.fileService.viewFile(this.uuid);
  }
  onDownloadFile(): void {
    this.fileService.downloadFile(this.uuid, this.fileName);
  }

  // convert size to bytes, KB, MB, or GB
  formatFileSize(): string {
    if (this.size < 1024) {
      return this.size + ' bytes';
    } else if (this.size < 1048576) {
      return (this.size / 1024).toFixed(2) + ' KB';
    } else if (this.size < 1073741824) {
      return (this.size / 1048576).toFixed(2) + ' MB';
    } else {
      return (this.size / 1073741824).toFixed(2) + ' GB';
    }
  }
}
